import { render, staticRenderFns } from "./RoundIcon.vue?vue&type=template&id=28cf126e&scoped=true"
var script = {}
import style0 from "./RoundIcon.vue?vue&type=style&index=0&id=28cf126e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cf126e",
  null
  
)

export default component.exports